var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-view',{attrs:{"root-page-full-path":_vm.rootPageFullPath,"with-tabs":_vm.withTabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }